import React, {
  Fragment,
  useRef,
  useState,
  useEffect,
  useMemo,
} from "react";
import "./navbar.css";
import "./CurveNavbar.css";
import { Nav } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import BrandLogo from "../../../components/BrandLogo/BrandLogo";
import { FaRegHeart } from "react-icons/fa";
import { FiLogOut, FiMenu } from "react-icons/fi";
import { AiOutlineClose } from "react-icons/ai";
import { MdArrowForwardIos } from "react-icons/md";
import Drawer from "../../components/Drawer";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { useContext } from "react";
import FeedbackContext from "../../context/cmscontext";
import {
  logoutDealerPortal,
  resolvePortalIdentity,
} from "../../utils/portalIdentity";
import { Provider } from "react-redux";
import clientStore from "../../../store";
import UserAccountMenu from "../../../components/UserAccountMenu";
import AccountQuickModal from "../../../components/AccountQuickModal";

const DEALER_ACCOUNT_PANELS = [
  { panel: "profile", label: "Edit profile" },
  { panel: "credits", label: "Credits & evaluations" },
  { panel: "password", label: "Change password" },
  { panel: "referral", label: "Invite friends" },
];

const DEALER_SHORTCUT_LINKS = [
  { to: "/dealers/dashbord", label: "Dealer dashboard" },
  { to: "/dealers/dashbord/auction", label: "Auctions" },
  { to: "/dealers/dashbord/buynow", label: "Buy now" },
];

const CurveNavbar = ({ setnavbarDimensions, auth, logOut, isHome = false }) => {
  const [mobileDrawer, setMobileDrawer] = useState(false);
  const [accountPanel, setAccountPanel] = useState(null);
  const [identityTick, setIdentityTick] = useState(0);
  const [avatarFailed, setAvatarFailed] = useState(false);
  const navbarContainer = useRef(null);
  const { feedback } = useContext(FeedbackContext);
  const curveNavBar = feedback.curveNavBar || feedback.home_page || {};
  const history = useHistory();

  const identity = useMemo(
    () => resolvePortalIdentity(auth),
    [auth, identityTick]
  );
  const isLoggedIn = Boolean(identity.kind);
  const displayName = identity.displayName;
  const initials = identity.initials;
  const avatarUrl = identity.avatarUrl;
  const roleLabel = identity.roleLabel || "Signed in";
  const showAvatar = Boolean(avatarUrl) && !avatarFailed;

  useEffect(() => {
    setAvatarFailed(false);
  }, [avatarUrl]);

  // Re-resolve when client storage may change outside dealers Redux.
  useEffect(() => {
    const onStorage = (event) => {
      if (
        !event.key ||
        event.key.includes("localstorage_auth") ||
        event.key === "ATP_localstorage_auth" ||
        event.key === "ATP_DEALERS_localstorage_auth"
      ) {
        setIdentityTick((n) => n + 1);
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const section2Buttons = [
    {
      title: "Home",
      to: "/",
    },
    {
      title: `${curveNavBar.buyTitle || "Buy Now"}`,
      to: "/dealers/dashbord/buynow",
    },
    {
      title: "Dashboard",
      to: "/dealers/dashbord",
    },
    {
      title: `${curveNavBar.auctionTitle || "Auctions"}`,
      to: "/dealers/dashbord/auction",
    },
    {
      title: `${curveNavBar.interestTitle || "Show Interest"}`,
      to: "/dealers/showInterest",
    },
    {
      title: `${curveNavBar.myInterest || "My Interest"}`,
      to: "/dealers/myInterest",
    },
  ];

  const section2Buttons_mbl = [
    {
      title: "Home",
      to: "/",
    },
    {
      title: "Trade floor",
      to: "/dealers",
    },
    ...section2Buttons.filter((item) => item.to !== "/"),
    {
      title: `${curveNavBar.bidsTitle || "My Bids"}`,
      to: "/dealers/winer",
    },
  ];

  useEffect(() => {
    function setnavbarDimensionsHandler() {
      if (!navbarContainer.current) return;
      if (navbarContainer.current.offsetWidth > 1023) {
        setMobileDrawer(false);
      }
      setnavbarDimensions({
        width: navbarContainer.current.offsetWidth,
        height: navbarContainer.current.offsetHeight,
      });
    }

    setnavbarDimensionsHandler();
    window.addEventListener("resize", setnavbarDimensionsHandler);
    return () =>
      window.removeEventListener("resize", setnavbarDimensionsHandler);
  }, [isHome, setnavbarDimensions]);

  const handlePortalLogout = () => {
    logOut();
    history.replace("/login");
  };

  const section1Buttons = [
    {
      title: `${curveNavBar.bidsTitle || "My Bids"}`,
      to: "/dealers/winer",
      icon: <FaRegHeart className="section1Button-icon" />,
    },
    ...(isLoggedIn
      ? [
          {
            title: `${curveNavBar.logoutLabel || "logout"}`,
            to: () => {
              handlePortalLogout();
            },
            icon: <FiLogOut className="section1Button-icon" />,
            isButton: true,
          },
        ]
      : []),
  ];

  const mobileviewRightButtons = isLoggedIn
    ? [
        {
          title: "logout",
          to: () => {
            handlePortalLogout();
          },
          icon: <FiLogOut className="mobile-nav-button-icon" />,
        },
      ]
    : [];

  const handleDrawer = () => {
    setMobileDrawer(!mobileDrawer);
  };

  /* Compact single-row header for dealers home */
  if (isHome) {
    return (
      <>
      <div
        id="curve-nav-bar-main-cont"
        ref={navbarContainer}
        className="pi-header pi-header--hero dealers-pi-header dealers-home-nav"
      >
        <div className="dealers-home-nav__inner">
          <div className="dealers-home-nav__brand">
            <BrandLogo
              variant="light"
              compact
              className="dealers-nav-logo"
              onClick={() => history.push("/dealers")}
            />
            <span className="dealers-nav-badge">Dealers</span>
          </div>

          <nav className="dealers-home-nav__links" aria-label="Dealers">
            {section2Buttons.slice(0, 5).map((item) => (
              <NavLink
                key={item.to}
                exact
                to={item.to}
                className="dealers-home-nav__link"
                activeClassName="is-active"
              >
                {item.title}
              </NavLink>
            ))}
          </nav>

          <div className="dealers-home-nav__actions">
            {isLoggedIn ? (
              <Provider store={clientStore.store}>
                <UserAccountMenu
                  onLogout={() => {
                    handlePortalLogout();
                    history.push("/");
                  }}
                />
              </Provider>
            ) : null}
            <button
              type="button"
              className="dealers-home-nav__menu"
              onClick={handleDrawer}
              aria-label="Open menu"
            >
              <FiMenu size={22} />
            </button>
          </div>
        </div>

        <div className="dealers-home-nav__drawer">
          <Drawer
            visible={mobileDrawer}
            handleDrawer={handleDrawer}
            body={
              <MobileDrawerBody
                handleDrawer={handleDrawer}
                section2Buttons_mbl={section2Buttons_mbl}
                dealerShortcutLinks={isLoggedIn ? DEALER_SHORTCUT_LINKS : []}
                accountPanelLinks={isLoggedIn ? DEALER_ACCOUNT_PANELS : []}
                onOpenAccount={(panel) => {
                  handleDrawer();
                  setAccountPanel(panel);
                }}
                onAuthClick={
                  isLoggedIn
                    ? () => {
                        handleDrawer();
                        handlePortalLogout();
                        history.push("/");
                      }
                    : null
                }
                isLoggedIn={isLoggedIn}
                dealerName={displayName}
                dealerInitials={initials}
                dealerAvatar={avatarUrl}
                roleLabel={roleLabel}
                authLabel={curveNavBar.logoutLabel || "Log out"}
              />
            }
          />
        </div>
      </div>
      {accountPanel ? (
        <Provider store={clientStore.store}>
          <AccountQuickModal
            open
            panel={accountPanel}
            onClose={() => setAccountPanel(null)}
          />
        </Provider>
      ) : null}
      </>
    );
  }

  return (
    <div
      id="curve-nav-bar-main-cont"
      ref={navbarContainer}
      className="pi-header pi-header--inner dealers-pi-header"
    >
      <div className="courve-nav-bar-container-desktop  ">
        <div className="courve-nav-bar-logo-container d-flex justify-content-start align-items-center">
          <BrandLogo
            variant="light"
            compact
            className="dealers-nav-logo"
            onClick={() => history.push("/dealers")}
          />
          <span className="dealers-nav-badge">Dealers</span>
        </div>
        <div className="courve-nav-bar-body d-flex flex-column justify-content-center align-items-end">
          <div className="courve-nav-bar-body-s courve-nav-bar-body-s1-main">
            <div className="courve-nav-bar-section-1-curve"></div>
            <div className="courve-nav-bar-body-s courve-nav-bar-body-s1 d-flex   justify-content-end align-items-center">
              {isLoggedIn ? (
                <div className="dealers-inner-nav__user" title={displayName}>
                  <span className="dealers-home-nav__avatar" aria-hidden="true">
                    {showAvatar ? (
                      <img
                        src={avatarUrl}
                        alt=""
                        onError={() => setAvatarFailed(true)}
                      />
                    ) : (
                      initials
                    )}
                  </span>
                  <span className="dealers-home-nav__user-meta dealers-inner-nav__user-meta">
                    <span className="dealers-home-nav__user-label">
                      {roleLabel}
                    </span>
                    <span className="dealers-home-nav__user-name">
                      {displayName}
                    </span>
                  </span>
                </div>
              ) : null}
              <Nav className="courve-nav-bar-body-s1-child d-flex   justify-content-between">
                {React.Children.toArray(
                  section1Buttons.map((item, index) => (
                    <Fragment>
                      {item.isButton ? (
                        <button
                          key={"section1btn" + index}
                          onClick={item.to}
                          className="mobile-nav-menu-button-s1 d-flex  justify-content-center align-items-center"
                        >
                          {item.icon} {item.title}
                        </button>
                      ) : (
                        <NavLink
                          exact
                          key={"NavLink" + index}
                          to={item.to}
                          activeClassName="section1Button-active"
                          className="section1Button d-flex justify-content-center align-items-center"
                        >
                          {item.icon} {item.title}
                        </NavLink>
                      )}
                      {index === section1Buttons.length - 1 ? null : (
                        <div
                          key={"vertical" + index}
                          className="vertical-divider"
                        />
                      )}
                    </Fragment>
                  ))
                )}
              </Nav>
            </div>
          </div>
          <div className="courve-nav-bar-body-s courve-nav-bar-body-s2 d-flex   justify-content-end align-items-center">
            <Nav className="courve-nav-bar-body-s1-child d-flex   justify-content-between">
              {React.Children.toArray(
                section2Buttons.map((item, index) => (
                  <NavLink
                    exact
                    to={item.to}
                    key={"NavLink2" + index}
                    activeClassName="selected"
                    className="unselected"
                  >
                    {item.title}
                  </NavLink>
                ))
              )}
            </Nav>
          </div>
        </div>
      </div>
      <div className="courve-nav-bar-container-mobile ">
        <div
          className="courve-nav-bar-logo-container d-flex justify-content-start align-items-center"
          style={{ flex: 1 }}
        >
          <BrandLogo
            variant="light"
            compact
            className="dealers-nav-logo"
            onClick={() => history.push("/dealers")}
          />
          <span className="dealers-nav-badge dealers-nav-badge--mobile">
            Dealers
          </span>
        </div>

        <Nav className="courve-nav-bar-mobile-left-button ">
          {React.Children.toArray(
            mobileviewRightButtons.map((item, index) => (
              <button
                key={"mobileviewRightButtonsr" + index}
                onClick={item.to}
                className="mobile-nav-menu-button d-flex flex-column justify-content-center align-items-center"
              >
                {item.icon} {item.title}
              </button>
            ))
          )}
          <button
            onClick={handleDrawer}
            className="mobile-nav-menu-button d-flex flex-column justify-content-center align-items-center"
          >
            <FiMenu className="mobile-nav-button-icon" />
            {mobileDrawer ? "close" : "menu"}
          </button>
        </Nav>

        <Drawer
          visible={mobileDrawer}
          handleDrawer={handleDrawer}
          body={
            <MobileDrawerBody
              handleDrawer={handleDrawer}
              section2Buttons_mbl={section2Buttons_mbl}
              onAuthClick={
                isLoggedIn
                  ? () => {
                      handleDrawer();
                      handlePortalLogout();
                    }
                  : null
              }
              isLoggedIn={isLoggedIn}
              dealerName={displayName}
              dealerInitials={initials}
              roleLabel={roleLabel}
              authLabel={curveNavBar.logoutLabel || "Log out"}
            />
          }
        />
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  auth: state.auth,
});
const mapDispatchToProps = (dispatch) => ({
  logOut: () => logoutDealerPortal(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(CurveNavbar);

const MobileDrawerBody = (props) => {
  const {
    handleDrawer,
    section2Buttons_mbl,
    onAuthClick,
    authLabel,
    isLoggedIn,
    dealerName,
    dealerInitials,
    dealerAvatar,
    roleLabel,
    dealerShortcutLinks = [],
    accountPanelLinks = [],
    onOpenAccount,
  } = props;
  const [avatarFailed, setAvatarFailed] = useState(false);
  const showAvatar = Boolean(dealerAvatar) && !avatarFailed;

  useEffect(() => {
    setAvatarFailed(false);
  }, [dealerAvatar]);

  return (
    <Fragment>
      <div className="courve-nav-bar-container-mobile d-flex align-items-center dealers-drawer-head">
        <div
          className="courve-nav-bar-logo-container d-flex justify-content-start align-items-center"
          style={{ flex: 1 }}
        >
          <BrandLogo variant="light" compact className="dealers-nav-logo" />
          <span className="dealers-nav-badge dealers-nav-badge--mobile">
            Dealers
          </span>
        </div>
        <button
          onClick={handleDrawer}
          className="mobile-nav-menu-button d-flex flex-column justify-content-center align-items-center"
        >
          <AiOutlineClose className="mobile-nav-button-icon" />
          close
        </button>
      </div>
      <div className="mobile-dawer-body-cont">
        {isLoggedIn ? (
          <div className="dealers-drawer-user">
            <span className="dealers-drawer-user__avatar" aria-hidden="true">
              {showAvatar ? (
                <img
                  src={dealerAvatar}
                  alt=""
                  onError={() => setAvatarFailed(true)}
                />
              ) : (
                dealerInitials || "U"
              )}
            </span>
            <div className="dealers-drawer-user__meta">
              <span className="dealers-drawer-user__label">
                {roleLabel || "Signed in"}
              </span>
              <span className="dealers-drawer-user__name">
                {dealerName || "Account"}
              </span>
            </div>
          </div>
        ) : null}
        {dealerShortcutLinks.map((item) => (
          <div className="mobile-dawer-body-links-cont" key={item.to}>
            <NavLink
              onClick={handleDrawer}
              exact
              to={item.to}
              className="mobile-dawer-body-links"
            >
              <span>{item.label}</span>
              <MdArrowForwardIos />
            </NavLink>
          </div>
        ))}
        {accountPanelLinks.map((item) => (
          <div className="mobile-dawer-body-links-cont" key={item.panel}>
            <button
              type="button"
              className="mobile-dawer-body-links dealers-drawer-account-btn"
              onClick={() => onOpenAccount?.(item.panel)}
            >
              <span>{item.label}</span>
              <MdArrowForwardIos />
            </button>
          </div>
        ))}
        {onAuthClick ? (
          <button
            type="button"
            className="dealers-drawer-login"
            onClick={onAuthClick}
          >
            <FiLogOut size={18} />
            {authLabel || "Log out"}
          </button>
        ) : null}
        {React.Children.toArray(
          section2Buttons_mbl.map((item, index) => (
            <div
              className="mobile-dawer-body-links-cont"
              key={"section1btncNavLinkrw" + index}
            >
              <NavLink
                key={"section1btncNavLink" + index}
                onClick={handleDrawer}
                exact
                to={item.to}
                className="mobile-dawer-body-links"
              >
                <span key={"span" + index}>{item.title}</span>
                <MdArrowForwardIos key={"MdArrowForwardIos" + index} />
              </NavLink>
            </div>
          ))
        )}
      </div>
    </Fragment>
  );
};
